import { Satisfaction } from 'lib-shared-legacy-types';

export namespace LanguageCustomizationForm {
  export enum Fields {
    subject = 'subject',
    body = 'body',
    ratingQuestion = 'ratingQuestion',
    ratingStyle = 'ratingStyle',
    headerText = 'headerText',
    subheaderText = 'subheaderText',
    placeholderText = 'placeholderText',
    actionButtonText = 'actionButtonText',
  }

  export interface FormValues {
    [Fields.subject]: string;
    [Fields.body]: string;
    [Fields.ratingQuestion]: string;
    [Fields.ratingStyle]: Satisfaction.RatingStyle;
    [Fields.headerText]: string;
    [Fields.subheaderText]: string;
    [Fields.actionButtonText]: string;
    [Fields.placeholderText]: string;
  }
}
